import React from 'react';

interface TutorialSpotlightProps {
  rect: DOMRect;
  offset?: { x?: number; y?: number };
}

export function TutorialSpotlight({ rect, offset = {} }: TutorialSpotlightProps) {
  const padding = 8;
  const xOffset = offset.x || 0;
  const yOffset = offset.y || 0;

  const spotlightStyle = {
    position: 'absolute' as const,
    left: rect.left + xOffset - padding,
    top: rect.top + yOffset - padding,
    width: rect.width + padding * 2,
    height: rect.height + padding * 2,
    pointerEvents: 'none' as const, // WICHTIG: Spotlight soll nicht blockieren!
    zIndex: 10001,
  };

  return (
    <>
      {/* White glow around target */}
      <div
        style={{
          ...spotlightStyle,
          background: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '8px',
          boxShadow: '0 0 0 4px rgba(255, 255, 255, 0.3), 0 0 20px 8px rgba(255, 255, 255, 0.2)',
          animation: 'pulse-glow 2s ease-in-out infinite',
        }}
      />

      {/* Clear area (cut-out from dark overlay) */}
      <div
        style={{
          ...spotlightStyle,
          background: 'transparent',
          boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.5)',
          borderRadius: '8px',
        }}
      />

      {/* Animated border */}
      <div
        style={{
          ...spotlightStyle,
          border: '2px solid var(--md-primary)',
          borderRadius: '8px',
          animation: 'pulse-border 2s ease-in-out infinite',
        }}
      />

      {/* Pulse Animation */}
      <style>{`
        @keyframes pulse-glow {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.6;
          }
        }
        
        @keyframes pulse-border {
          0%, 100% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.02);
            opacity: 0.8;
          }
        }
      `}</style>
    </>
  );
}